import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  FormHelperText,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { soapApi } from "../../../redux/actions/api";
import {
  clearSupplierDetails,
  createOrderInvoice,
  createStocksForPending,
  deleteSupplierDetailById,
  getPendingStocksByClinic,
  getPurchaseHistoryByStockIdWoLoader,
  getSupplierDetailsByType,
  updateStockDetailsById,
  updateSupplierDetailStatusById,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { AppColors } from "../../../util/AppColors";
import { addIcon, delBtn, plusBtn } from "../../../util/CommonIconStyle";
import { administeredUOMList, purchaseTypes } from "../../../util/dropList";
import {
  getExactNumber,
  getTotalValues,
  normalizeDate,
} from "../../../util/function";
import { tblGrayBack } from "../../../util/object";

const initObj = {
  hsnSacCode: "",
  name: "",
  quantity: "1",
  packageUom: "",
  purchaseUom: null,
  gst: 0,
  cgst: 0,
  sgst: 0,
  taxableValue: 0,
  taxes: 0,
  itemTotal: 0,
};
const initStckVal = {
  supplierName: "",
  billDate: null,
  invoiceNumber: "",
  poNumber: "",
  grnNumber: "",
  list: [],
  purchaseType: { name: "Intrastate", value: "Intrastate" },
  expectedDelivery: new Date(),
};
const stckRequiredFields = ["supplierName", "invoiceNumber"];
const tblHdrs = [
  "invoice",
  "supplier",
  "date",
  "amount",
  "status",
  "extraStatus",
];
const nameExpan = {
  invoice: "PO",
  supplier: "Supplier",
  date: "Date",
  amount: "Amount",
  status: "Status",
  extraStatus: "",
};

const stckEntTblHdrs = [
  // "sno",
  // "hsnSacCode",
  // "name",
  // // "orderedQuantity",
  // "quantity",
  // "purchaseUom",
  // "cgst",
  // "sgst",
  // "taxableValue",
  // "taxes",
  // "itemTotal",
  // "status",
  "sno",
  "name",
  "hsnSacCode",
  // "mrp",
  // "batchNumber",
  // "expiryDate",
  "quantity",
  "purchaseUom",
  "taxableValue",
  "cgst",
  "sgst",
  // "taxes",
  "itemTotal",
  "status",
];
const stckEntTblHdrsWitOrder = [
  "sno",
  "hsnSacCode",
  "name",
  "orderedQuantity",
  "quantity",
  "purchaseUom",
  "cgst",
  "sgst",
  "taxableValue",
  "taxes",
  "itemTotal",
  "status",
];
const stckEntIgstTblHdrs = [
  // "sno",
  // "hsnSacCode",
  // "name",
  // // "orderedQuantity",
  // "quantity",
  // "purchaseUom",
  // "gst",
  // "taxableValue",
  // "taxes",
  // "itemTotal",
  // "status",

  "sno",
  "name",
  "hsnSacCode",
  // "mrp",
  // "batchNumber",
  // "expiryDate",
  "quantity",
  "purchaseUom",
  "taxableValue",
  "gst",
  // "taxes",
  "itemTotal",
  "status",
];
const stckEntIgstTblHdrsWitOrder = [
  "sno",
  "name",
  "hsnSacCode",
  // "mrp",
  // "batchNumber",
  // "expiryDate",
  "orderedQuantity",
  "quantity",
  "purchaseUom",
  "taxableValue",
  "gst",
  // "taxes",
  "itemTotal",
  "status",
  // "sno",
  // "hsnSacCode",
  // "name",
  // "orderedQuantity",
  // "quantity",
  // "purchaseUom",
  // "gst",
  // "taxableValue",
  // "taxes",
  // "itemTotal",
  // "status",
];

const stckNmeExpan = {
  icon: "",
  sno: "S No",
  hsnSacCode: "HSN Code",
  name: "Name *",
  quantity: "Ordered Qty *",
  cgst: "CGST % *",
  sgst: "SGST % *",
  gst: "IGST % *",
  taxableValue: "Taxable Value *",
  taxes: "Taxes *",
  itemTotal: "Item Total *",
  purchaseUom: "UOM *",
};
const reqTxt = "This field is required";
const initSearch = {
  startDate: null,
  endDate: null,
  supplierName: "",
  poNumber: "",
  grnNumber: "",
};
const defObj = { stocks: [], suppliers: [] };

const PurchaseOrders = () => {
  const dispatch = useDispatch();
  const fetchRef = useRef(false);
  const [modVsble, setModVsble] = useState(false);
  const [modValues, setModValues] = useState({});
  const [delModVsble, setDelModVsble] = useState(false);
  const [markModVsble, setMarkModVsble] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [page, setPage] = useState(1);
  const [stcEntModVsble, setStcEntModVsble] = useState(false);
  const [stcEntFiles, setStcEntFiles] = useState([]);
  const [stckValue, setStckValue] = useState(initStckVal);
  const [actStep, setActStep] = useState(1);
  const [stckErrs, setStckErrs] = useState({});
  const [stckHelps, setStckHelps] = useState({});
  const [submitErr, setSubmitErr] = useState(false);
  const [stockEntrErr, setStockEntErr] = useState(false);
  const [isListNotValid, setListNotValid] = useState(false);
  const [isManualEntry, setMaualEntry] = useState(false);
  const itemSize = 10;
  const { supplierDetails } = useSelector((state) => state?.clinic);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { stocks: clinicStocks, suppliers } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        suppliers: Array.isArray(reqData?.suppliers) ? reqData?.suppliers : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(clearSupplierDetails());

    const timeoutId = setTimeout(() => {
      void (async () => {
        // Purchase orders list first — wait for response, then pending stocks (once)
        await onApiCall(1);
        if (!fetchRef.current) {
          fetchRef.current = true;
          dispatch(getPendingStocksByClinic(`?type=pending&page=1&itemSize=1`));
        }
      })();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    searchValues?.startDate,
    searchValues?.endDate,
    searchValues?.supplierName,
    searchValues?.poNumber,
    searchValues?.grnNumber,
  ]);

  const getResolvedDateRange = () => {
    const startRaw = searchValues?.startDate;
    const endRaw = searchValues?.endDate;
    if (!startRaw && !endRaw) return { startDate: null, endDate: null };

    const start = startRaw ? moment(new Date(startRaw)) : null;
    let end = endRaw ? moment(new Date(endRaw)) : null;

    // If endDate is missing, use startDate
    if (start && !end) end = start.clone();
    // If only endDate exists, use it for both
    if (!start && end) {
      return {
        startDate: end.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
      };
    }
    // If endDate is earlier than startDate, swap
    if (start && end && end.isBefore(start, "day")) {
      return {
        startDate: end.format("YYYY-MM-DD"),
        endDate: start.format("YYYY-MM-DD"),
      };
    }

    return {
      startDate: start?.format("YYYY-MM-DD") ?? null,
      endDate: end?.format("YYYY-MM-DD") ?? null,
    };
  };

  const onApiCall = (pge = 1) => {
    setPage(pge);
    const { startDate, endDate } = getResolvedDateRange();
    let reqUrl = `?type=po&itemSize=${itemSize}&page=${pge}`;
    if (startDate) reqUrl += `&startDate=${startDate}`;
    if (endDate) reqUrl += `&endDate=${endDate}`;
    if (searchValues?.supplierName?.length > 0) {
      reqUrl += `&search=${searchValues?.supplierName}`;
    }
    if (searchValues?.poNumber?.length > 0) {
      reqUrl += `&poNumber=${searchValues?.poNumber}`;
    }
    if (searchValues?.grnNumber?.length > 0) {
      reqUrl += `&grnNumber=${searchValues?.grnNumber}`;
    }
    return dispatch(getSupplierDetailsByType(reqUrl));
  };

  const handleDelete = (itm) => {
    setSelectedInvoice(itm);
    setDelModVsble(true);
  };

  const onMarkAsReceived = (itm) => {
    setSelectedInvoice(itm);
    setMarkModVsble(true);
  };

  const tableList = () => {
    const reqList = (supplierDetails?.data ?? [])
      ?.map((li) => ({ ...li, ...(li?.supplier ?? {}) }))
      ?.map((li) => {
        const reqStat =
          (li?.creditSave ?? "")?.toLowerCase() === "submitted" ||
          (li?.creditSave ?? "")?.toLowerCase() === "submit"
            ? "Awaiting Receipt"
            : (li?.creditSave ?? "")?.toLowerCase() === "received"
              ? "Received"
              : "Draft";
        return {
          ...li,
          invoice: li?.poNumber ?? "-",
          supplier: li?.supplierName,
          amount: Number(li?.grandTotal)?.toFixed(2),
          date: moment(new Date(li?.billDate)).format("DD MMM YYYY"),
          status: (
            <div
              className={`fs10 white-color br5 con-fit ph10 pv3 font-bold ${reqStat === "Received" ? "green-back5" : reqStat === "Awaiting Receipt" ? "card-con-blue-back" : "card-top-yellow-color"}`}
            >
              {reqStat}
            </div>
          ),
          extraStatus: (
            <div className="flex-row-ali-cen">
              <div className="cursor" onClick={() => onSelectInvoice(li)}>
                <div className="flex-center">
                  <VisibilityIcon sx={plusBtn} />
                </div>
                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                  View
                </Typography>
              </div>
              <div className="cursor ml15" onClick={() => handleDelete(li)}>
                <div className="flex-center">
                  <DeleteOutlineIcon sx={delBtn} />
                </div>
                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                  Delete
                </Typography>
              </div>
              {reqStat === "Awaiting Receipt" ? (
                <div
                  className="cursor ml15"
                  onClick={() => onMarkAsReceived(li)}
                >
                  <div className="flex-center">
                    <LibraryAddCheckIcon sx={addIcon} />
                  </div>
                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                    Mark as Received
                  </Typography>
                </div>
              ) : null}
            </div>
          ),
        };
      });
    return reqList;
  };

  const onCloseMod = () => {
    setSelectedInvoice(null);
    setModVsble(false);
  };

  const onSelectInvoice = (inv) => {
    setSelectedInvoice(inv);
    if (
      (inv?.creditSave ?? "")?.toLowerCase() === "submitted" ||
      (inv?.creditSave ?? "")?.toLowerCase() === "received"
    ) {
      setModVsble(true);
    } else {
      const reqPurType = purchaseTypes?.find(
        (li) =>
          li?.value?.toLowerCase() === (inv?.purchaseType ?? "")?.toLowerCase(),
      );
      const reqList = (inv?.supplierInvoiceDetails ?? [])?.map((li) => {
        const reqUom = administeredUOMList?.find(
          (al) =>
            al?.value?.toLowerCase() === (li?.purchaseUom ?? "")?.toLowerCase(),
        );
        return {
          invoiceDetailId: li?.invoiceDetailId ?? null,
          hsnSacCode: li?.hsnSacCode ?? "",
          name: li?.tradeName ?? li?.name ?? "",
          quantity: li?.quantity,
          packageUom: "",
          purchaseUom: reqUom ? reqUom : null,
          gst: Number(li?.cgst ?? 0) * 2,
          igst: Number(li?.cgst ?? 0) * 2,
          cgst: li?.cgst,
          sgst: li?.sgst,
          taxableValue: li?.taxableValue,
          taxes: li?.taxes,
          itemTotal: li?.itemTotal,
          landedCost: li?.landedCost,
        };
      });
      const reqObj = {
        supplierName: inv?.supplierName,
        billDate: new Date(inv?.billDate),
        invoiceNumber: inv?.invoiceNumber ?? "",
        poNumber: inv?.poNumber ?? "",
        grnNumber: inv?.grnNumber ?? "",
        list: reqList,
        purchaseType: reqPurType ? reqPurType : null,
        supplierId: inv?.supplierId ?? null,
        additionalCharges: inv?.additionalCharges,
        email: inv?.email ?? "",
        phone: inv?.phone ?? "",
        address: inv?.address ?? "",
        GSTIN: inv?.gstin ?? "",
        totalTaxableValue: inv?.totalTaxableValue ?? 0,
        totalTaxes: inv?.totalTaxes ?? 0,
        additionalCharges: inv?.additionalCharges ?? 0,
        grandTotal: inv?.grandTotal ?? 0,
        type: inv?.type,
        creditSave: inv?.creditSave,
        expectedDelivery: new Date(inv?.expectedDeliveryDate),
      };
      setStckValue(reqObj);
      setActStep(2);
      setStcEntModVsble(true);
    }
  };

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleCreate = () => {
    setMaualEntry(false);
    setActStep(2);
    setStcEntModVsble(true);
  };

  const handleCloseStcEnt = () => {
    setStcEntModVsble(false);
    setStckValue(initStckVal);
    setStcEntFiles([]);
    setActStep(1);
    setSubmitErr(false);
    setStockEntErr(false);
    setListNotValid(false);
    setSelectedInvoice(null);
    setMarkModVsble(false);
  };

  const onEntFileUpload = (e) => {
    const fileList = e?.target?.files;
    let fileLists = stcEntFiles?.length > 0 ? [...stcEntFiles] : [];

    const readFiles = Array.from(fileList).map((file, i) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
              i,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => {
        setStcEntFiles(fileLists);
        setListNotValid(fileLists?.length > 0 ? false : true);
      })
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqList = stcEntFiles
      ?.filter((fle, i) => i !== ind)
      ?.map((fle, i) => ({ ...fle, i }));
    setStcEntFiles(reqList);
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const handleManualAddEntry = () => {
    setMaualEntry(false);
    setActStep(2);
    setStcEntModVsble(true);
  };

  const handleManualValidationCheck = () => {
    let hlpLi = {},
      errLi = {};
    if (
      (stckValue?.supplierName === null || stckValue?.supplierName?.length) ===
      0
    ) {
      errLi["supplierName"] = true;
      hlpLi["supplierName"] = reqTxt;
    }
    // if (
    //   stckValue?.invoiceNumber === null ||
    //   stckValue?.invoiceNumber?.length === 0
    // ) {
    //   errLi["invoiceNumber"] = true;
    //   hlpLi["invoiceNumber"] = reqTxt;
    // }
    if (stckValue?.billDate === null || stckValue?.billDate === undefined) {
      errLi = { ...errLi, billDate: true };
      hlpLi = { ...hlpLi, billDate: reqTxt };
    }

    setStckHelps({ ...stckHelps, ...hlpLi });
    setStckErrs({ ...stckErrs, ...errLi });
    return Object.values(errLi).some((item) => item);
  };

  const handleChangeStckValue = (name, value, addObj) => {
    const reqObj = { ...stckValue, [name]: value };
    const reqValue = typeof value === "object" ? value?.value : value;
    if (name === "supplierName" && addObj?.supplierId) {
      reqObj.GSTIN = addObj?.gstNumber ?? null;
      reqObj.email = addObj?.email ?? null;
      reqObj.phone = addObj?.phone ?? null;
      reqObj.supplierId = addObj?.supplierId ?? null;
    }
    const reqErrs = {
      ...stckErrs,
      [name]:
        reqValue?.length > 0
          ? false
          : stckRequiredFields?.includes(name)
            ? true
            : false,
    };

    const reqHelps = {
      ...stckHelps,
      [name]:
        reqValue?.length > 0
          ? ""
          : stckRequiredFields?.includes(name)
            ? "This is required field"
            : "",
    };
    if (name === "billDate") {
      if (value === null) {
        reqErrs[name] = true;
        reqHelps[name] = "This is required field";
      } else {
        reqErrs[name] = false;
        reqHelps[name] = "";
      }
    }
    if (name === "purchaseType") {
      reqObj.list = stckValue?.list?.map((li) => {
        const obj = {
          ...li,
          cgst:
            value?.value === "Intrastate"
              ? Number(li?.gst ?? li?.igst ?? 0) / 2
              : 0,
          sgst:
            value?.value === "Intrastate"
              ? Number(li?.gst ?? li?.igst ?? 0) / 2
              : 0,
          igst:
            value?.value === "Interstate"
              ? Number(li?.gst ?? li?.igst ?? 0)
              : 0,
        };
        if (value?.value === "Exempt") {
          obj.taxes = 0;
          obj.itemTotal = Number(li?.taxableValue) * Number(li?.quantity);
        }
        if (value?.value !== "Exempt") {
          const reqTaxes = Number(li?.taxableValue) * (li?.gst / 100);
          obj.taxes = reqTaxes * (li?.quantity ?? 0);
          obj.itemTotal =
            (Number(li?.taxableValue) + Number(reqTaxes)) * (li?.quantity ?? 0);
        }
        return obj;
      });
    }
    setStckValue(reqObj);
    setStckHelps(reqHelps);
    setStckErrs(reqErrs);
  };

  const handleChangeAdditionalCharge = (name, value) => {
    setStckValue({ ...stckValue, [name]: value });
  };

  const getSupplierList = () => {
    const reqList = (suppliers ?? [])
      ?.map((sup) => ({
        name: sup?.supplierName,
        value: sup?.supplierName,
        supplierId: sup?.supplierId,
        gstNumber: sup?.gstNumber,
        email: sup?.email,
        phone: sup?.phone,
      }))
      ?.sort((a, b) => a?.name?.localeCompare(b?.name));
    return reqList;
  };

  const handleDeleteRow = (ind) => {
    const reqList = stckValue?.list
      ?.filter((li, i) => i !== ind)
      ?.map((li, i) => ({ ...li, i }));
    setStckValue({ ...stckValue, list: reqList });
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const onStcEntUpload = async () => {
    if (stcEntFiles?.length === 0 || !stcEntFiles) return setListNotValid(true);
    dispatch(showLoader());
    const form = new FormData();
    stcEntFiles?.forEach((fle) => {
      form.append("files", fle?.file);
    });

    try {
      const apiRes = await soapApi.post("/purchase", form);
      if (apiRes?.status === 200) {
        const reqDta = apiRes?.data;
        const reqList = reqDta?.Items?.map((itm, i) => {
          const reqCgst =
            reqDta?.Purchasetype === "Intrastate"
              ? Number(itm?.GST ?? 0) / 2
              : 0;
          const reqSgst =
            reqDta?.Purchasetype === "Intrastate"
              ? Number(itm?.GST ?? 0) / 2
              : 0;
          const reqUom = administeredUOMList?.find(
            (al) =>
              al?.value?.toLowerCase() ===
              (itm?.Purchaseuom ?? "")?.toLowerCase(),
          );
          return {
            ...itm,
            hsnSacCode: itm?.HSNSAC,
            name: itm?.Name,
            quantity: itm?.Quantity,
            cgst: reqCgst,
            sgst: reqSgst,
            gst: Number(itm?.GST ?? 0),
            igst: Number(itm?.GST ?? 0),
            taxes: itm?.Taxes ?? 0,
            itemTotal: itm?.Itemtotal ?? 0,
            landedCost: itm?.landedCost ?? 0,
            purchaseUom: reqUom ? reqUom : null,
            taxableValue: itm?.Taxablevalue ?? 0,
            i,
            apiCalled: false,
            apiResponse: null,
          };
        });
        const reqObj = {
          ...reqDta,
          additionalCharges: getExactNumber(reqDta?.Additionalcharges),
          address: reqDta?.Address,
          billDate:
            reqDta?.Billdate?.length > 0
              ? new Date(normalizeDate(reqDta?.Billdate))
              : new Date(),
          email: reqDta?.Email,
          GSTIN: reqDta?.GSTIN,
          grandtotal: reqDta?.Grandtotal,
          invoiceNumber: reqDta?.Invoicenumber,
          phone: reqDta?.Phone ?? "",
          supplierName: reqDta?.Suppliername,
          //  reqSupplier ? { name: reqSupplier?.supplierName, value: reqSupplier?.supplierName, supplierId: reqSupplier?.supplierId } : null,          ,
          totaltaxablevalue: reqDta?.Totaltaxablevalue ?? 0,
          totalTaxes: reqDta?.Totaltaxes ?? 0,
          list: reqList,
          purchaseType: {
            name: reqDta?.Purchasetype,
            value: reqDta?.Purchasetype,
          },
        };
        setStcEntFiles([]);
        setStckValue(reqObj);
        setActStep(2);
        setStockEntErr(false);
        dispatch(hideLoader());
      } else {
        dispatch(hideLoader());
      }
    } catch (err) {
      console.log("err", err);
      dispatch(hideLoader());
    }
  };

  const validateStockList = (list, purchaseType) => {
    const errors = [];

    list?.forEach((item, index) => {
      const itemErrors = {};

      // Required fields
      if (!item?.name || item?.name?.trim() === "") {
        itemErrors.name = "Product name is required";
      }

      if (!item?.quantity || Number(item?.quantity) <= 0) {
        itemErrors.quantity = "Quantity must be greater than 0";
      }

      if (!item?.purchaseUom?.value) {
        itemErrors.purchaseUom = "UOM is required";
      }

      // Tax validation based on purchase type
      if (purchaseType !== "Exempt") {
        if (purchaseType === "Interstate") {
          if (
            item?.gst === undefined ||
            item?.gst === null ||
            item?.gst === "" ||
            Number(item?.gst) < 0
          ) {
            itemErrors.gst = "GST must be 0 or positive";
          }
        } else {
          if (
            item?.cgst === undefined ||
            item?.cgst === null ||
            item?.cgst === "" ||
            Number(item?.cgst) < 0
          ) {
            itemErrors.cgst = "CGST must be 0 or positive";
          }
          if (
            item?.sgst === undefined ||
            item?.sgst === null ||
            item?.sgst === "" ||
            Number(item?.sgst) < 0
          ) {
            itemErrors.sgst = "SGST must be 0 or positive";
          }
        }
      }

      // Validate item total
      if (!item?.itemTotal || Number(item?.itemTotal) <= 0) {
        itemErrors.itemTotal = "Item total must be greater than 0";
      }

      // Validate tax calculations
      const taxableValue = Number(item?.taxableValue) || 0;
      if (taxableValue <= 0) {
        itemErrors.taxableValue = "Taxable value must be greater than 0";
      }

      if (Object.keys(itemErrors).length > 0) {
        errors[index] = itemErrors;
      }
    });

    return errors;
  };

  const onStcApiCall = (typ) => {
    if (handleManualValidationCheck()) return;
    if (stckValue?.list?.length === 0 || !stckValue?.list) {
      return setListNotValid(true);
    } else {
      setListNotValid(false);
    }
    const listErrors = validateStockList(
      stckValue.list,
      stckValue.purchaseType?.value,
    );
    // Validate stock list

    if (listErrors.length > 0) {
      // Update state to show errors
      const updatedList = stckValue.list.map((item, index) => ({
        ...item,
        errors: listErrors[index] || {},
      }));
      setStckValue({ ...stckValue, list: updatedList });
      return setListNotValid(true);
    }

    if (handleValidate()?.length > 0 || !stckValue?.purchaseType) {
      return setListNotValid(true);
    } else {
      setListNotValid(false);
    }

    // if (selectedInvoice && !markModVsble) {
    //   const reqData = {
    //     supplierDetials: {
    //       type: "PO",
    //       supplierName: stckValue?.supplierName?.toString() ?? "",
    //       supplierId:
    //         stckValue?.supplierId ?? selectedInvoice?.supplierId ?? null,
    //       gstNumber: stckValue?.GSTIN ?? "",
    //       email: stckValue?.email ?? "",
    //       phone: stckValue?.phone ?? "",
    //       address: stckValue?.address ?? "",
    //       date: moment(new Date(stckValue?.billDate)).format("YYYY-MM-DD"),
    //       expectedDeliveryDate: moment(
    //         new Date(stckValue?.expectedDelivery),
    //       ).format("YYYY-MM-DD"),
    //       purchaseType: stckValue?.purchaseType?.value,
    //       poNumber: stckValue?.poNumber ?? "",
    //       invoiceNumber: stckValue?.invoiceNumber ?? "",
    //       creditSave: typ,
    //       totalTaxableValue:
    //         getTotalValues({
    //           list: stckValue?.list,
    //           additionalCharges: stckValue?.additionalCharges,
    //         })?.taxableValues ?? 0,
    //       totalTaxes:
    //         getTotalValues({
    //           list: stckValue?.list,
    //           additionalCharges: stckValue?.additionalCharges,
    //         })?.taxes ?? 0,
    //       additionalCharges: Number(stckValue?.additionalCharges) ?? 0,
    //       grandTotal: Number(
    //         getTotalValues({
    //           list: stckValue?.list,
    //           additionalCharges: stckValue?.additionalCharges,
    //         })?.grandTotal ?? 0,
    //       ),
    //       invoiceDetails: stckValue?.list?.map((itm) => {
    //         return {
    //           invoiceDetailId: itm?.invoiceDetailId ?? null,
    //           hsnSacCode: itm?.hsnSacCode ?? itm?.HSNSAC ?? "",
    //           name: itm?.name ?? itm?.Name ?? "",
    //           tradeName: itm?.name ?? itm?.Name ?? "",
    //           stockId: itm?.stockId ?? null,
    //           orderedQuantity: null,
    //           quantity: Number(getExactNumber(itm?.quantity)) ?? 1,
    //           uom: itm?.purchaseUom?.value,
    //           cgst:
    //             stckValue?.purchaseType?.value === "Intrastate"
    //               ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
    //               : 0,
    //           sgst:
    //             stckValue?.purchaseType?.value === "Intrastate"
    //               ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
    //               : 0,
    //           igst:
    //             stckValue?.purchaseType?.value === "Interstate"
    //               ? Number(itm?.igst ?? 0)
    //               : 0,
    //           taxableValue: Number(itm?.taxableValue) ?? 0,
    //           taxes: Number(itm?.taxes) ?? 0,
    //           itemTotal: Number(itm?.itemTotal) ?? 0,
    //           landedCost:
    //             Number(
    //               (Number(itm?.itemTotal) ?? 0) /
    //                 (Number(getExactNumber(itm?.quantity)) ?? 1),
    //             ) ?? 0,
    //         };
    //       }),
    //     },
    //   };
    //   dispatch(
    //     updateStockDetailsById({
    //       data: reqData,
    //       id: selectedInvoice?.detailId,
    //     }),
    //   ).then((res) => {
    //     if (res?.payload) {
    //       onApiCall(1);
    //       setStcEntModVsble(false);
    //       setStckValue(initStckVal);
    //       setStckErrs({});
    //       setStckHelps({});
    //       setActStep(1);
    //       setSubmitErr(false);
    //       setMarkModVsble(false);
    //       setSelectedInvoice(null);
    //     }
    //   });
    //   return;
    // }
    dispatch(showLoader());
    const data = {
      supplierDetials: {
        type: markModVsble && selectedInvoice ? "Invoice" : "PO",
        supplierName: stckValue?.supplierName?.toString() ?? "",
        supplierId:
          stckValue?.supplierId ?? selectedInvoice?.supplierId ?? null,
        gstNumber: stckValue?.GSTIN ?? "",
        email: stckValue?.email ?? "",
        phone: stckValue?.phone ?? "",
        address: stckValue?.address ?? "",
        date: moment(new Date(stckValue?.billDate)).format("YYYY-MM-DD"),
        expectedDeliveryDate: moment(
          new Date(stckValue?.expectedDelivery),
        ).format("YYYY-MM-DD"),
        purchaseType: stckValue?.purchaseType?.value,
        poNumber: stckValue?.poNumber ?? "",
        invoiceNumber: stckValue?.invoiceNumber ?? "",
        grnNumber: stckValue?.grnNumber ?? "",
        creditSave: typ,
        totalTaxableValue:
          getTotalValues({
            list: stckValue?.list,
            additionalCharges: stckValue?.additionalCharges,
          })?.taxableValues ?? 0,
        totalTaxes:
          getTotalValues({
            list: stckValue?.list,
            additionalCharges: stckValue?.additionalCharges,
          })?.taxes ?? 0,
        additionalCharges: Number(stckValue?.additionalCharges) ?? 0,
        grandTotal: Number(
          getTotalValues({
            list: stckValue?.list,
            additionalCharges: stckValue?.additionalCharges,
          })?.grandTotal ?? 0,
        ),
        invoiceDetails: stckValue?.list?.map((itm) => {
          return {
            invoiceDetailId: itm?.invoiceDetailId ?? null,
            hsnSacCode: itm?.hsnSacCode ?? itm?.HSNSAC ?? "",
            name: itm?.name ?? itm?.Name ?? "",
            tradeName: itm?.name ?? itm?.Name ?? "",
            stockId: itm?.stockId ?? null,
            orderedQuantity: itm?.orderedQuantity ?? null,
            quantity: Number(getExactNumber(itm?.quantity)) ?? 1,
            uom: itm?.purchaseUom?.value,
            cgst:
              stckValue?.purchaseType?.value === "Intrastate"
                ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
                : 0,
            sgst:
              stckValue?.purchaseType?.value === "Intrastate"
                ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
                : 0,
            igst:
              stckValue?.purchaseType?.value === "Interstate"
                ? Number(itm?.igst ?? 0)
                : 0,
            taxableValue: Number(itm?.taxableValue) ?? 0,
            taxes: Number(itm?.taxes) ?? 0,
            itemTotal: Number(itm?.itemTotal) ?? 0,
            landedCost:
              Number(
                (Number(itm?.itemTotal) ?? 0) /
                  (Number(getExactNumber(itm?.quantity)) ?? 1),
              ) ?? 0,
          };
        }),
      },
    };
    // let stocks = [];
    // if (stckValue?.list?.length > 0) {
    //   stocks = stckValue?.list?.map((itm) => {
    //     return {
    //       skuId: "",
    //       purchaseUom: itm?.purchaseUom?.value,
    //       hsnSacCode: itm?.hsnSacCode ?? itm?.HSNSAC,
    //       tradeName: itm?.name ?? itm?.Name,
    //       orderedQuantity: itm?.orderedQuantity ?? null,
    //       quantity: Number(getExactNumber(itm?.quantity)) ?? 1,
    //       cgst:
    //         stckValue?.purchaseType?.value === "Intrastate"
    //           ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
    //           : 0,
    //       sgst:
    //         stckValue?.purchaseType?.value === "Intrastate"
    //           ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
    //           : 0,
    //       igst:
    //         stckValue?.purchaseType?.value === "Interstate"
    //           ? Number(itm?.igst ?? 0)
    //           : 0,
    //       taxes: Number(itm?.taxes) ?? 0,
    //       taxableValue: Number(itm?.taxableValue) ?? 0,
    //       itemTotal: Number(itm?.itemTotal) ?? 0,
    //       landedCost:
    //         Number(
    //           (Number(itm?.itemTotal) ?? 0) /
    //             (Number(getExactNumber(itm?.quantity)) ?? 1),
    //         ) ?? 0,
    //       status: false,
    //       product: null,
    //       dosage: itm?.dosage ?? "",
    //       dosageType: itm?.dosageType?.value ?? null,
    //     };
    //   });
    // }
    // const data = {
    //   supplierName: stckValue?.supplierName?.toString() ?? "",
    //   date: moment().format("YYYY-MM-DD"),
    //   email: stckValue?.email ?? "",
    //   phone: stckValue?.phone,
    //   address: stckValue?.address ?? "",
    //   gstNumber: stckValue?.GSTIN ?? "",
    //   billDate: moment(new Date(stckValue?.billDate)).format("YYYY-MM-DD"),
    //   invoiceNumber:
    //     markModVsble && selectedInvoice ? stckValue?.invoiceNumber : "",
    //   poNumber: markModVsble && selectedInvoice ? "" : stckValue?.poNumber,
    //   totalTaxableValue:
    //     getTotalValues({
    //       list: stckValue?.list,
    //       additionalCharges: stckValue?.additionalCharges,
    //     })?.taxableValues ?? 0,
    //   totalTaxes:
    //     getTotalValues({
    //       list: stckValue?.list,
    //       additionalCharges: stckValue?.additionalCharges,
    //     })?.taxes ?? 0,
    //   additionalCharges: Number(stckValue?.additionalCharges) ?? 0,
    //   grandTotal: Number(
    //     getTotalValues({
    //       list: stckValue?.list,
    //       additionalCharges: stckValue?.additionalCharges,
    //     })?.grandTotal,
    //   ),
    //   purchaseType: stckValue?.purchaseType?.value,
    //   stocks,
    //   type: markModVsble && selectedInvoice ? "Invoice" : "PO",
    //   creditSave: typ,
    //   expectedDeliveryDate: moment(
    //     new Date(stckValue?.expectedDelivery),
    //   ).format("YYYY-MM-DD"),
    // };
    // if (markModVsble && selectedInvoice) {
    //   delete data.expectedDeliveryDate;
    // }
    try {
      (!markModVsble && selectedInvoice?.detailId
        ? dispatch(
            updateStockDetailsById({ data, id: selectedInvoice?.detailId }),
          )
        : dispatch(createOrderInvoice(data))
      ).then((res) => {
        if (res?.payload) {
          if (markModVsble && selectedInvoice && typ === "Submitted") {
            let stocks = [];
            if (stckValue?.list?.length > 0) {
              stocks = stckValue?.list?.map((itm) => {
                return {
                  skuId: "",
                  purchaseUom: itm?.purchaseUom?.value,
                  hsnSacCode: itm?.hsnSacCode ?? itm?.HSNSAC,
                  tradeName: itm?.name ?? itm?.Name,
                  orderedQuantity: itm?.orderedQuantity ?? null,
                  quantity: Number(getExactNumber(itm?.quantity)) ?? 1,
                  cgst:
                    stckValue?.purchaseType?.value === "Intrastate"
                      ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
                      : 0,
                  sgst:
                    stckValue?.purchaseType?.value === "Intrastate"
                      ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
                      : 0,
                  igst:
                    stckValue?.purchaseType?.value === "Interstate"
                      ? Number(itm?.igst ?? 0)
                      : 0,
                  taxes: Number(itm?.taxes) ?? 0,
                  taxableValue: Number(itm?.taxableValue) ?? 0,
                  itemTotal: Number(itm?.itemTotal) ?? 0,
                  landedCost:
                    Number(
                      (Number(itm?.itemTotal) ?? 0) /
                        (Number(getExactNumber(itm?.quantity)) ?? 1),
                    ) ?? 0,
                  status: false,
                  product: null,
                  dosage: itm?.dosage ?? "",
                  dosageType: itm?.dosageType?.value ?? null,
                };
              });
            }
            const stockData = {
              supplierName: stckValue?.supplierName?.toString() ?? "",
              date: moment().format("YYYY-MM-DD"),
              email: stckValue?.email ?? "",
              phone: stckValue?.phone,
              address: stckValue?.address ?? "",
              gstNumber: stckValue?.GSTIN ?? "",
              billDate: moment(new Date(stckValue?.billDate)).format(
                "YYYY-MM-DD",
              ),
              invoiceNumber: stckValue?.invoiceNumber ?? "",
              poNumber: stckValue?.poNumber ?? "",
              grnNumber: stckValue?.grnNumber ?? "",
              totalTaxableValue:
                getTotalValues({
                  list: stckValue?.list,
                  additionalCharges: stckValue?.additionalCharges,
                })?.taxableValues ?? 0,
              totalTaxes:
                getTotalValues({
                  list: stckValue?.list,
                  additionalCharges: stckValue?.additionalCharges,
                })?.taxes ?? 0,
              additionalCharges: Number(stckValue?.additionalCharges) ?? 0,
              grandTotal: Number(
                getTotalValues({
                  list: stckValue?.list,
                  additionalCharges: stckValue?.additionalCharges,
                })?.grandTotal,
              ),
              purchaseType: stckValue?.purchaseType?.value,
              stocks,
              type: markModVsble && selectedInvoice ? "Invoice" : "PO",
              creditSave: typ,
              expectedDeliveryDate: moment(
                new Date(stckValue?.expectedDelivery),
              ).format("YYYY-MM-DD"),
            };
            dispatch(createStocksForPending(stockData));
          }
          if (markModVsble && selectedInvoice) {
            dispatch(
              updateSupplierDetailStatusById({
                id: selectedInvoice?.detailId,
                url: `?creditSave=Received&grnNumber=${stckValue?.grnNumber ?? ""}`,
              }),
            ).then((res2) => {
              if (res2?.payload) onApiCall(1);
            });
          } else {
            onApiCall(1);
          }
          setStcEntModVsble(false);
          setStckValue(initStckVal);
          setStckErrs({});
          setStckHelps({});
          setActStep(1);
          setSubmitErr(false);
          setMarkModVsble(false);
          setSelectedInvoice(null);
        }
      });
    } catch (err) {
      dispatch(hideLoader());
      console.log("Err");
    }
  };

  const handleAdd = () => {
    const reqList = [
      ...(stckValue?.list ?? []),
      {
        ...initObj,
        i: (stckValue?.list ?? [])?.length ?? 0,
        apiCalled: false,
        apiResponse: null,
      },
    ];
    setStckValue({ ...stckValue, list: reqList });
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const handleChangeTableValue = (name, value, ind, addObj) => {
    const purchaseType = stckValue?.purchaseType?.value;
    const reqList = stckValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = {
          ...li,
          [name]: value,
          errors: { ...(li.errors || {}), [name]: undefined },
        };
        if (name === "name" && addObj?.stockId) {
          reqObj.stockId = addObj.stockId;
          dispatch(getPurchaseHistoryByStockIdWoLoader(addObj?.stockId)).then(
            (res) => {
              if (res?.payload) {
                const reqTranList = [...(res?.payload?.purchases ?? [])]?.sort(
                  (a, b) => {
                    return (
                      new Date(b?.purchaseDate ?? new Date()) -
                      new Date(a?.purchaseDate ?? new Date())
                    );
                  },
                );
                if (reqTranList?.length > 0) {
                  const reqLatData = reqTranList?.[0];
                  const uomMat = administeredUOMList?.find(
                    (al) =>
                      al?.value?.toLowerCase() ===
                      (
                        reqLatData?.purchaseUom ??
                        reqLatData?.uom ??
                        ""
                      )?.toLowerCase(),
                  );
                  setStckValue((prev) => ({
                    ...prev,
                    list: prev?.list?.map((row, rowInd) => {
                      if (rowInd !== ind) return row;
                      const cgst = reqLatData?.cgst ?? 0;
                      const sgst = reqLatData?.sgst ?? 0;
                      const gst = Number(cgst) * 2;
                      const updated = {
                        ...row,
                        stockId: addObj?.stockId,
                        cgst,
                        sgst,
                        gst,
                        purchaseUom: uomMat ?? row?.purchaseUom,
                      };
                      const taxableValue = Number(
                        reqLatData?.taxableValue ?? reqLatData?.landedCost ?? 0,
                      );
                      if (taxableValue > 0) {
                        const taxPercent =
                          purchaseType === "Interstate"
                            ? gst
                            : Number(cgst) + Number(sgst);
                        const reqTaxes = Number(
                          taxableValue * (taxPercent / 100),
                        );
                        updated.taxableValue = taxableValue;
                        updated.taxes = reqTaxes;
                        updated.itemTotal = taxableValue + reqTaxes;
                      }
                      return updated;
                    }),
                  }));
                }
              }
            },
          );
        }
        const errors = { ...(li.errors || {}) };
        const reqValue =
          typeof value === "object" ? (value?.value ?? "")?.toString() : value;
        switch (name) {
          case "name":
            if (!reqValue || reqValue?.trim() === "") {
              errors.name = "Product name is required";
            } else {
              delete errors.name;
            }
            break;

          case "quantity":
            if (!reqValue || Number(reqValue) <= 0) {
              errors.quantity = "Quantity must be greater than 0";
            } else {
              delete errors.quantity;
            }
            break;

          case "purchaseUom":
            if (!reqValue || reqValue?.trim() === "") {
              errors.purchaseUom = "UOM is required";
            } else {
              delete errors.purchaseUom;
            }
            break;

          case "gst":
            if (
              purchaseType === "Interstate" &&
              (!reqValue || Number(reqValue) < 0)
            ) {
              errors.gst = "GST must be 0 or positive";
            } else {
              delete errors.gst;
            }
            break;

          case "cgst":
          case "sgst":
            if (
              purchaseType !== "Interstate" &&
              (!reqValue || Number(reqValue) < 0)
            ) {
              errors[name] = `${name.toUpperCase()} must be 0 or positive`;
            } else {
              delete errors[name];
            }
            break;

          case "taxableValue":
            if (!reqValue || Number(reqValue) <= 0) {
              errors.taxableValue = "Taxable value must be positive";
            } else {
              delete errors.taxableValue;
            }
            break;

          case "itemTotal":
            if (!reqValue || Number(reqValue) <= 0) {
              errors.itemTotal = "Item total must be positive";
            } else {
              delete errors.itemTotal;
            }
            break;

          default:
            break;
        }
        if (
          name === "taxableValue" ||
          name === "sgst" ||
          name === "cgst" ||
          name === "gst" ||
          name === "quantity"
        ) {
          if (name === "sgst" || name === "cgst") {
            reqObj.cgst = value;
            reqObj.sgst = value;
            reqObj.gst = Number(value) * 2;
          }
          if (name === "gst") {
            reqObj.cgst = Number(value) / 2;
            reqObj.sgst = Number(value) / 2;
            reqObj.gst = value;
          }
          const reqQty = Number(
            name === "quantity" ? (value ?? 0) : (reqObj.quantity ?? 0),
          );
          const reqTaxableValue =
            name === "taxableValue" ? Number(value) : Number(li?.taxableValue);
          const taxPercent =
            stckValue?.purchaseType?.value === "Interstate"
              ? Number(name === "gst" ? value : li?.gst)
              : Number(name === "cgst" || name === "sgst" ? value : li?.cgst) +
                Number(name === "sgst" || name === "cgst" ? value : li?.sgst);
          const reqTaxes = Number(reqTaxableValue * (taxPercent / 100));
          reqObj.taxes = Number(reqTaxes ?? 0) * Number(reqQty ?? 0);
          reqObj.itemTotal =
            (Number(reqTaxableValue) + Number(reqTaxes)) * Number(reqQty ?? 0);
        }
        if (name === "itemTotal") {
          const reqPer = (100 + Number(li?.gst)) / 100;
          const reqTaxableValue = Number(
            Number(value) / Number(reqPer),
          )?.toFixed(2);
          reqObj.taxes = Number(value) - reqTaxableValue;
          reqObj.taxableValue = reqTaxableValue;
          reqObj.itemTotal = value;
        }
        return { ...reqObj, errors };
      }
      return li;
    });
    setStckValue({ ...stckValue, list: reqList });
  };

  const handleValidate = () => {
    return stckValue?.list?.filter((li) => {
      const nameEmpty = li?.name?.length === 0 || li?.name === "" || !li?.name;
      const noQty = Number(li?.quantity) < 1 || !Number(li?.quantity);
      const uomEmpty =
        li?.purchaseUom?.length === 0 ||
        li?.purchaseUom === "" ||
        !li?.purchaseUom;
      const noCgst = Number(li?.cgst) < 0;
      const noSgst = Number(li?.sgst) < 0;
      const totalEmpty =
        Number(li?.itemTotal) < 0 || !li?.itemTotal || li?.itemTotal === "";
      return nameEmpty || noQty || uomEmpty || noCgst || noSgst || totalEmpty;
    });
  };

  const getStockList = () => {
    const reqList = clinicStocks
      ?.filter((stc) => stc?.active === "Y")
      ?.map((li) => ({
        name: li?.tradeName ?? li?.productName,
        value: li?.tradeName ?? li?.productName,
        stockId: li?.stockId,
        type: li?.category,
        productName: li?.productName,
        tradeName: li?.tradeName,
      }));
    return reqList ?? [];
  };

  const getUOMListByStockId = (stkId = null) => {
    if (!stkId) return [];
    const stockMat =
      clinicStocks?.find((stc) => stc?.stockId === stkId) ?? null;
    if (!stockMat) return [];
    return (
      (stockMat?.uomMappings ?? [])
        ?.filter((ml) => ml?.unit)
        ?.map((ml) => ({ name: ml?.unit, value: ml?.unit })) ?? []
    );
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedInvoice(null);
  };

  const onConfirmDelete = () => {
    if (selectedInvoice?.detailId) {
      dispatch(deleteSupplierDetailById(selectedInvoice?.detailId)).then(
        (res) => {
          if (res?.payload) {
            onApiCall(1);
            onCloseDelMod();
          }
        },
      );
    }
  };

  const onCloseMarkMod = () => {
    setMarkModVsble(false);
    setSelectedInvoice(null);
  };

  const onConfirmMarkYes = () => {
    const inv = selectedInvoice;
    const reqPurType = purchaseTypes?.find(
      (li) =>
        li?.value?.toLowerCase() === (inv?.purchaseType ?? "")?.toLowerCase(),
    );
    const reqList = (inv?.supplierInvoiceDetails ?? [])?.map((li) => {
      const reqUom = administeredUOMList?.find(
        (al) =>
          al?.value?.toLowerCase() === (li?.purchaseUom ?? "")?.toLowerCase(),
      );
      return {
        invoiceDetailId: null,
        hsnSacCode: li?.hsnSacCode ?? "",
        name: li?.tradeName ?? li?.name ?? "",
        orderedQuantity: li?.quantity,
        quantity: li?.quantity,
        packageUom: "",
        purchaseUom: reqUom ? reqUom : null,
        gst: Number(li?.cgst ?? 0) * 2,
        igst: Number(li?.cgst ?? 0) * 2,
        cgst: li?.cgst,
        sgst: li?.sgst,
        taxableValue: li?.taxableValue,
        taxes: li?.taxes,
        itemTotal: li?.itemTotal,
        landedCost: li?.landedCost,
      };
    });
    const reqObj = {
      supplierName: inv?.supplierName,
      billDate: new Date(inv?.expectedDeliveryDate),
      expectedDelivery: new Date(inv?.expectedDeliveryDate),
      invoiceNumber: inv?.invoiceNumber ?? "",
      poNumber: inv?.poNumber ?? "",
      list: reqList,
      purchaseType: reqPurType ? reqPurType : null,
      supplierId: inv?.supplierId ?? null,
      additionalCharges: inv?.additionalCharges,
      email: inv?.email ?? "",
      phone: inv?.phone ?? "",
      address: inv?.address ?? "",
      GSTIN: inv?.gstin ?? "",
      totalTaxableValue: inv?.totalTaxableValue ?? 0,
      totalTaxes: inv?.totalTaxes ?? 0,
      additionalCharges: inv?.additionalCharges ?? 0,
      grandTotal: inv?.grandTotal ?? 0,
      type: inv?.type,
      creditSave: inv?.creditSave,
    };
    setStckValue(reqObj);
    setStckValue(reqObj);
    setActStep(2);
    setStcEntModVsble(true);
  };

  const reqTableHeaders = (typ) => {
    const reqType =
      typ ?? stckValue?.purchaseType?.value?.toLowerCase() === "interstate";
    return reqType === "interstate"
      ? markModVsble
        ? stckEntIgstTblHdrsWitOrder
        : stckEntIgstTblHdrs
      : markModVsble
        ? stckEntTblHdrsWitOrder
        : stckEntTblHdrs;
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    setSearchValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
  };

  return (
    <>
      <div className="com-mar back-white pv10">
        <div className="flex-row-ali-cen w100Per">
          <div className="flex-center w100Per">
            <div className="w15Per">
              <CustomTextField
                placeholder="Start Date"
                fullWidth
                name="startDate"
                handleChange={onSearchChange}
                value={searchValues?.startDate}
                backgroundColor={AppColors.lightBlue2}
                label="Start Date"
                mobileDate
              />
            </div>
            <div className="w15Per ml15">
              <CustomTextField
                placeholder="End Date"
                fullWidth
                name="endDate"
                handleChange={onSearchChange}
                value={searchValues?.endDate}
                backgroundColor={AppColors.lightBlue2}
                label="End Date"
                mobileDate
              />
            </div>
            <div className="w15Per ml15">
              <CustomTextField
                placeholder="Supplier"
                fullWidth
                name="supplierName"
                handleChange={onSearchChange}
                value={searchValues?.supplierName}
                backgroundColor={AppColors.lightBlue2}
                label="Supplier"
              />
            </div>
            <div className="w15Per ml15">
              <CustomTextField
                placeholder="PO Number"
                fullWidth
                name="poNumber"
                handleChange={onSearchChange}
                value={searchValues?.poNumber}
                backgroundColor={AppColors.lightBlue2}
                label="PO Number"
              />
            </div>
            <div className="w15Per ml15">
              <CustomTextField
                placeholder="GRN Number"
                fullWidth
                name="grnNumber"
                handleChange={onSearchChange}
                value={searchValues?.grnNumber}
                backgroundColor={AppColors.lightBlue2}
                label="GRN Number"
              />
            </div>
            <div className="ml15">
              <CustomButton text="Reset" smallBtn onClick={onReset} redBtn />
            </div>
            <div className="ml15">
              <CustomButton text="Create" smallBtn onClick={handleCreate} />
            </div>
          </div>
        </div>
        <div className="ml20">
          <Typography className="font-medium fs12 gray28 mt5">
            Number of records: {supplierDetails?.totalRecords ?? 0}
          </Typography>
        </div>
        <Box className="ph20">
          <TableContainer sx={{ maxHeight: "65vh" }} className="mb20 mt10">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {tblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className="txt-semi-bold fs12"
                      key={hdr + i}
                    >
                      <div>{nameExpan?.[hdr]}</div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {supplierDetails?.totalRecords === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}
              <TableBody>
                {tableList()?.map((li, ind) => {
                  return (
                    <TableRow>
                      {tblHdrs?.map((hdr, i) => {
                        return (
                          <TableCell key={`${ind} + ${i} + tr`} component="th">
                            <div>
                              {hdr === "supplier" ? (
                                <Custom3dotString
                                  str={li?.[hdr]}
                                  className="font-regular fs14"
                                />
                              ) : (
                                // hdr === "invoice" ? (
                                //   <div
                                //     className="cursor"
                                //     onClick={() => onSelectInvoice(li)}
                                //   >
                                //     <Custom3dotString
                                //       str={li?.[hdr]}
                                //       className="font-regular fs14 blue4"
                                //     />
                                //   </div>
                                // ) :
                                li?.[hdr]
                              )}
                            </div>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
              {Math.ceil(supplierDetails?.totalRecords / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(
                            supplierDetails?.totalRecords / itemSize,
                          )}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Box>
      </div>

      <CustomModal
        open={modVsble}
        onClose={onCloseMod}
        header="Purchase Order"
        headerCenter
        modalWidth={90}
        modal
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="mv10">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div className="mb20">
                <CustomSelect
                  list={[
                    {
                      name: selectedInvoice?.supplierName,
                      value: selectedInvoice?.supplierName,
                    },
                  ]}
                  value={selectedInvoice?.supplierName}
                  label="Supplier Name"
                  select
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div className="mb20">
                <CustomTextField
                  name="GSTIN"
                  fullWidth
                  value={selectedInvoice?.gstin}
                  label="GSTIN"
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  fullWidth
                  value={selectedInvoice?.email}
                  label="Email"
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  fullWidth
                  value={selectedInvoice?.phone}
                  label="Phone"
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  fullWidth
                  value={selectedInvoice?.address}
                  multiline
                  rows={3}
                  label="Address"
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  fullWidth
                  value={selectedInvoice?.poNumber}
                  label="PO Number"
                  required={true}
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  fullWidth
                  value={selectedInvoice?.grnNumber}
                  label="GRN Number"
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="date"
                  fullWidth
                  value={selectedInvoice?.billDate}
                  mobileDateWithBatch
                  label="Date *"
                  required={true}
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomSelect
                  list={purchaseTypes}
                  value={selectedInvoice?.purchaseType}
                  label="Purchase Type"
                  select
                  disabled
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="expectedDelivery"
                  fullWidth
                  value={selectedInvoice?.expectedDeliveryDate}
                  mobileDateWithBatch
                  label="Expected Delivery *"
                  required={true}
                  disabled
                />
              </div>
            </Grid>
          </Grid>
          <TableContainer sx={{ maxHeight: 300 }} className="mb20">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {reqTableHeaders(selectedInvoice?.purchaseType?.toLowerCase())
                    ?.slice(0, -1)
                    ?.map((hdr, i) => (
                      <TableCell
                        style={tblGrayBack}
                        className={`table-header-text`}
                      >
                        <div
                          style={{
                            width:
                              hdr === "sno"
                                ? 30
                                : hdr === "hsnSacCode" || hdr === "itemTotal"
                                  ? 120
                                  : hdr === "name"
                                    ? 200
                                    : hdr === "quantity" ||
                                        hdr === "samples" ||
                                        hdr === "cgst" ||
                                        hdr === "sgst" ||
                                        hdr === "gst" ||
                                        i ===
                                          reqTableHeaders(
                                            selectedInvoice?.purchaseType?.toLowerCase(),
                                          )?.length -
                                            1
                                      ? 70
                                      : hdr === "purchaseUom"
                                        ? 100
                                        : hdr === "discounts"
                                          ? 80
                                          : 130,
                          }}
                        >
                          {stckNmeExpan?.[hdr]}
                        </div>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(selectedInvoice?.supplierInvoiceDetails ?? [])?.map(
                  (li, ind) => {
                    return (
                      <TableRow>
                        {reqTableHeaders(
                          selectedInvoice?.purchaseType?.toLowerCase(),
                        )
                          ?.slice(0, -1)
                          ?.map((hdr, i) => (
                            <TableCell
                              key={ind + `${i}` + "tr"}
                              component="th"
                              sx={{ verticalAlign: "top" }}
                            >
                              <div
                                style={{
                                  width:
                                    hdr === "sno"
                                      ? 30
                                      : hdr === "hsnSacCode" ||
                                          hdr === "itemTotal"
                                        ? 120
                                        : hdr === "name"
                                          ? 200
                                          : hdr === "quantity" ||
                                              hdr === "samples" ||
                                              hdr === "cgst" ||
                                              hdr === "sgst" ||
                                              hdr === "gst"
                                            ? 70
                                            : hdr === "purchaseUom"
                                              ? 100
                                              : hdr === "discounts"
                                                ? 80
                                                : 130,
                                }}
                              >
                                {hdr === "sno" ? (
                                  ind + 1
                                ) : (
                                  <CustomTextField
                                    fullWidth
                                    value={
                                      hdr === "name"
                                        ? (li?.tradeName ?? "")
                                        : hdr === "taxes" ||
                                            hdr === "taxableValue" ||
                                            hdr === "itemTotal"
                                          ? Number(li?.[hdr])?.toFixed(2)
                                          : li?.[hdr]
                                    }
                                    disabled
                                  />
                                )}
                              </div>
                            </TableCell>
                          ))}
                      </TableRow>
                    );
                  },
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <div className="flex1-end pr50">
            <div className="w25Per">
              <div className="flex-row-ali-cen">
                <div className="w60Per">
                  <div className="font-medium fs14 black">
                    Total Taxable Value
                  </div>
                </div>
                <div className="flex1-end pr10">
                  {Number(
                    getTotalValues({
                      list: selectedInvoice?.supplierInvoiceDetails ?? [],
                      additionalCharges: selectedInvoice?.additionalCharges,
                    })?.taxableValues,
                  )?.toFixed(2)}
                </div>
              </div>
              {selectedInvoice?.purchaseType?.toLowerCase() === "interstate" ? (
                <div className="flex-row-ali-cen mt10">
                  <div className="w60Per">
                    <div className="font-medium fs14 black">Taxes (IGST)</div>
                  </div>
                  <div className="flex1-end pr10">
                    {Number(
                      getTotalValues({
                        list: selectedInvoice?.supplierInvoiceDetails ?? [],
                        additionalCharges: selectedInvoice?.additionalCharges,
                      })?.taxes,
                    )?.toFixed(2)}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="w60Per">
                      <div className="font-medium fs14 black">Taxes (CGST)</div>
                    </div>
                    <div className="flex1-end pr10">
                      {Number(
                        Number(
                          getTotalValues({
                            list: selectedInvoice?.supplierInvoiceDetails ?? [],
                            additionalCharges:
                              selectedInvoice?.additionalCharges,
                          })?.taxes,
                        ) / 2,
                      )?.toFixed(2)}
                    </div>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="w60Per">
                      <div className="font-medium fs14 black">Taxes (SGST)</div>
                    </div>
                    <div className="flex1-end pr10">
                      {Number(
                        Number(
                          getTotalValues({
                            list: selectedInvoice?.supplierInvoiceDetails ?? [],
                            additionalCharges:
                              selectedInvoice?.additionalCharges,
                          })?.taxes,
                        ) / 2,
                      )?.toFixed(2)}
                    </div>
                  </div>
                </div>
              )}
              <div className="flex-row-ali-cen mt10">
                <div className="w60Per">
                  <div className="font-medium fs14 black">
                    Additional Charges
                  </div>
                </div>
                <div className="flex1-end">
                  <CustomTextField
                    fullWidth
                    value={selectedInvoice?.additionalCharges}
                    type="number"
                    textRightAlign
                    disabled
                  />
                </div>
              </div>
              <div className="flex-row-ali-cen mt10">
                <div className="flex-start">
                  <div className="font-medium fs14 black">Grand Total</div>
                </div>
                <div className="flex1-end pr10">
                  <div className="font-bold fs14 black">
                    {Number(
                      getTotalValues({
                        list: selectedInvoice?.supplierInvoiceDetails ?? [],
                        additionalCharges: selectedInvoice?.additionalCharges,
                      })?.grandTotal,
                    )?.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={stcEntModVsble}
        onClose={handleCloseStcEnt}
        header={`Purchase ${markModVsble ? "Invoice" : "Order"}`}
        headerCenter
        modalWidth={actStep === 1 ? 40 : 90}
        modal
      >
        <div className="scroll-90vh">
          <Grid container spacing={0} className="pb20">
            {actStep === 1 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row-ali-cen flex-center">
                  <Typography className="txt-semi-bold fs16 black">
                    Step {actStep}:
                  </Typography>
                  <Typography className="ml5 font-medium fs16 black">
                    Upload a clear picture of your supplier invoice
                  </Typography>
                </div>
              </Grid>
            ) : null}
            {actStep === 1 ? null : (
              <>
                <Grid container spacing={2} className="mv10">
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomSelect
                        list={getSupplierList()}
                        handleChange={(e, value) => {
                          handleChangeStckValue(
                            "supplierName",
                            e?.value ?? e,
                            e,
                          );
                        }}
                        value={stckValue?.supplierName}
                        label="Supplier Name *"
                        error={stckErrs?.supplierName}
                        helperText={stckHelps?.supplierName}
                        // search
                        addNewSelect
                        plusBtn
                        addSearchDirectly
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="GSTIN"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("GSTIN", e?.target?.value)
                        }
                        value={stckValue?.GSTIN}
                        label="GSTIN"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="email"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("email", e?.target?.value)
                        }
                        value={stckValue?.email}
                        label="Email"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="phone"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("phone", e?.target?.value)
                        }
                        value={stckValue?.phone}
                        label="Phone"
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="address"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("address", e?.target?.value)
                        }
                        value={stckValue?.address}
                        multiline
                        rows={3}
                        label="Address"
                      />
                    </div>
                  </Grid>
                  {selectedInvoice && !markModVsble ? (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <div class="mb20">
                        <CustomTextField
                          name="poNumber"
                          fullWidth
                          handleChange={(e) =>
                            handleChangeStckValue("poNumber", e?.target?.value)
                          }
                          value={stckValue?.poNumber}
                          label="PO Number"
                        />
                      </div>
                    </Grid>
                  ) : null}
                  {selectedInvoice && markModVsble ? (
                    <>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                        <div class="mb20">
                          <CustomTextField
                            name="invoiceNumber"
                            fullWidth
                            handleChange={(e) =>
                              handleChangeStckValue(
                                "invoiceNumber",
                                e?.target?.value,
                              )
                            }
                            value={stckValue?.invoiceNumber}
                            label="Invoice Number"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                        <div class="mb20">
                          <CustomTextField
                            name="grnNumber"
                            fullWidth
                            handleChange={(e) =>
                              handleChangeStckValue(
                                "grnNumber",
                                e?.target?.value,
                              )
                            }
                            value={stckValue?.grnNumber}
                            label="GRN number"
                          />
                        </div>
                      </Grid>
                    </>
                  ) : null}
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="date"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("billDate", e?.target?.value)
                        }
                        value={stckValue?.billDate}
                        mobileDateWithBatch
                        label="Date *"
                        required={true}
                        error={stckErrs?.billDate}
                        helperText={stckHelps?.billDate}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomSelect
                        list={purchaseTypes}
                        handleChange={(e, value) =>
                          handleChangeStckValue("purchaseType", value)
                        }
                        value={stckValue?.purchaseType}
                        label="Purchase Type"
                        search
                      />
                    </div>
                  </Grid>
                  {markModVsble && selectedInvoice ? null : (
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <div class="mb20">
                        <CustomTextField
                          name="expectedDelivery"
                          fullWidth
                          handleChange={(e) =>
                            handleChangeStckValue(
                              "expectedDelivery",
                              e?.target?.value,
                            )
                          }
                          value={stckValue?.expectedDelivery}
                          mobileDateWithBatch
                          label="Expected Delivery *"
                          required
                          error={stckErrs?.expectedDelivery}
                          helperText={stckHelps?.expectedDelivery}
                        />
                      </div>
                    </Grid>
                  )}
                </Grid>

                <TableContainer sx={{ maxHeight: 300 }} className="mb20">
                  <Table
                    sx={{ minWidth: 200 }}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        {reqTableHeaders()?.map((hdr, i) => (
                          <TableCell
                            style={tblGrayBack}
                            className={`table-header-text`}
                          >
                            <div
                              style={{
                                width:
                                  hdr === "sno"
                                    ? 30
                                    : hdr === "hsnSacCode"
                                      ? 120
                                      : hdr === "name"
                                        ? 200
                                        : hdr === "quantity" ||
                                            hdr === "samples" ||
                                            hdr === "cgst" ||
                                            hdr === "sgst" ||
                                            hdr === "gst" ||
                                            i ===
                                              reqTableHeaders(
                                                stckValue?.purchaseType?.value?.toLowerCase(),
                                              )?.length -
                                                1
                                          ? 70
                                          : hdr === "purchaseUom"
                                            ? 100
                                            : hdr === "discounts"
                                              ? 80
                                              : 130,
                              }}
                            >
                              {hdr === "orderedQuantity"
                                ? "Ordered Quantity"
                                : hdr === "quantity" && markModVsble
                                  ? "Receiving Quantity *"
                                  : stckNmeExpan?.[hdr]}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stckValue?.list?.map((li, ind) => {
                        return (
                          <TableRow>
                            {reqTableHeaders()?.map((hdr, i) => (
                              <TableCell
                                key={ind + `${i}` + "tr"}
                                component="th"
                                sx={{ verticalAlign: "top" }}
                              >
                                <div
                                  style={{
                                    width:
                                      hdr === "sno"
                                        ? 30
                                        : hdr === "hsnSacCode"
                                          ? 120
                                          : hdr === "name"
                                            ? 200
                                            : hdr === "quantity" ||
                                                hdr === "samples" ||
                                                hdr === "cgst" ||
                                                hdr === "sgst" ||
                                                hdr === "gst" ||
                                                i ===
                                                  reqTableHeaders()?.length - 1
                                              ? 70
                                              : hdr === "purchaseUom"
                                                ? 100
                                                : hdr === "discounts"
                                                  ? 80
                                                  : 130,
                                  }}
                                >
                                  {i === reqTableHeaders()?.length - 1 ? (
                                    <img
                                      src={require("../../../assets/images/png/delete.png")}
                                      className="imghw30 cursor mt5"
                                      onClick={() => handleDeleteRow(ind)}
                                    />
                                  ) : li?.apiCalled ? (
                                    hdr === "name" ? (
                                      <Custom3dotString
                                        str={li?.[hdr]}
                                        className="font-regular fs14"
                                        length={13}
                                      />
                                    ) : (
                                      (li?.product?.[hdr] ?? li?.[hdr])
                                    )
                                  ) : hdr === "sno" ? (
                                    ind + 1
                                  ) : hdr === "name" ? (
                                    <CustomSelect
                                      list={getStockList()}
                                      handleChange={(e, value) => {
                                        handleChangeTableValue(
                                          hdr,
                                          e?.value ?? e,
                                          ind,
                                          e,
                                        );
                                      }}
                                      value={li?.[hdr]}
                                      label=""
                                      error={!!li?.errors?.[hdr]}
                                      helperText={li?.errors?.[hdr]}
                                      addNewSelect
                                      plusBtn
                                      addSearchDirectly
                                      disabled={
                                        li?.invoiceDetailId && markModVsble
                                      }
                                    />
                                  ) : hdr === "purchaseUom" ? (
                                    <CustomSelect
                                      list={getUOMListByStockId(li?.stockId)}
                                      value={li?.[hdr]}
                                      handleChange={(e, value) =>
                                        handleChangeTableValue(hdr, value, ind)
                                      }
                                      name="uom"
                                      search
                                      error={!!li?.errors?.[hdr]}
                                      helperText={li?.errors?.[hdr]}
                                    />
                                  ) : (
                                    <CustomTextField
                                      name={hdr}
                                      fullWidth
                                      handleChange={(e) =>
                                        handleChangeTableValue(
                                          hdr,
                                          e?.target?.value,
                                          ind,
                                        )
                                      }
                                      error={!!li?.errors?.[hdr]}
                                      helperText={li?.errors?.[hdr]}
                                      value={
                                        hdr === "taxes"
                                          ? Number(li?.[hdr])?.toFixed(2)
                                          : li?.[hdr]
                                      }
                                      disabled={
                                        hdr === "itemTotal" ||
                                        hdr === "taxes" ||
                                        (stckValue?.purchaseType?.value ===
                                        "Exempt"
                                          ? hdr === "cgst" || hdr === "sgst"
                                          : false) ||
                                        (markModVsble &&
                                          [
                                            "hsnSacCode",
                                            "orderedQuantity",
                                          ].includes(hdr))
                                      }
                                      type={
                                        hdr === "hsnSacCode" ||
                                        hdr === "name" ||
                                        hdr === "purchaseUom"
                                          ? "string"
                                          : "number"
                                      }
                                    />
                                  )}
                                </div>
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div>
                  <CustomButton text="Add" smallBtn onClick={handleAdd} />
                </div>
                <div className="flex1-end pr50">
                  <div className="w25Per">
                    <div className="flex-row-ali-cen">
                      <div className="w60Per">
                        <div className="font-medium fs14 black">
                          Total Taxable Value
                        </div>
                      </div>
                      <div className="flex1-end pr10">
                        {Number(
                          getTotalValues({
                            list: stckValue?.list,
                            additionalCharges: stckValue?.additionalCharges,
                          })?.taxableValues,
                        )?.toFixed(2)}
                      </div>
                    </div>
                    {stckValue?.purchaseType?.value === "Interstate" ? (
                      <div className="flex-row-ali-cen mt10">
                        <div className="w60Per">
                          <div className="font-medium fs14 black">
                            Taxes (IGST)
                          </div>
                        </div>
                        <div className="flex1-end pr10">
                          {Number(
                            getTotalValues({
                              list: stckValue?.list,
                              additionalCharges: stckValue?.additionalCharges,
                            })?.taxes,
                          )?.toFixed(2)}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="flex-row-ali-cen mt10">
                          <div className="w60Per">
                            <div className="font-medium fs14 black">
                              Taxes (CGST)
                            </div>
                          </div>
                          <div className="flex1-end pr10">
                            {Number(
                              Number(
                                getTotalValues({
                                  list: stckValue?.list,
                                  additionalCharges:
                                    stckValue?.additionalCharges,
                                })?.taxes,
                              ) / 2,
                            )?.toFixed(2)}
                          </div>
                        </div>
                        <div className="flex-row-ali-cen mt10">
                          <div className="w60Per">
                            <div className="font-medium fs14 black">
                              Taxes (SGST)
                            </div>
                          </div>
                          <div className="flex1-end pr10">
                            {Number(
                              Number(
                                getTotalValues({
                                  list: stckValue?.list,
                                  additionalCharges:
                                    stckValue?.additionalCharges,
                                })?.taxes,
                              ) / 2,
                            )?.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="flex-row-ali-cen mt10">
                      <div className="w60Per">
                        <div className="font-medium fs14 black">
                          Additional Charges
                        </div>
                      </div>
                      <div className="flex1-end">
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangeAdditionalCharge(
                              "additionalCharges",
                              e?.target?.value,
                            )
                          }
                          value={stckValue?.additionalCharges}
                          type="number"
                          textRightAlign
                        />
                      </div>
                    </div>
                    <div className="flex-row-ali-cen mt10">
                      <div className="flex-start">
                        <div className="font-medium fs14 black">
                          Grand Total
                        </div>
                      </div>
                      <div className="flex1-end pr10">
                        <div className="font-bold fs14 black">
                          {Number(
                            getTotalValues({
                              list: stckValue?.list,
                              additionalCharges: stckValue?.additionalCharges,
                            })?.grandTotal,
                          )?.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {actStep === 1 ? (
                stockEntrErr ? (
                  <div className="flex-center mb10">
                    <FormHelperText error>
                      Unable to process the request. Kindly upload a clear
                      picture and try again.
                    </FormHelperText>
                  </div>
                ) : null
              ) : submitErr ? (
                <div className="flex-center mb10">
                  <FormHelperText error>
                    Please upload images against each product to complete the
                    process or skip to continue later.
                  </FormHelperText>
                </div>
              ) : null}

              {isListNotValid ? (
                <div className="flex-center mb10">
                  <FormHelperText error>
                    Please add at least 1 record
                  </FormHelperText>
                </div>
              ) : null}

              <div className="flex-center">
                <div className="flex-row">
                  {actStep === 2 ? (
                    <div>
                      <CustomButton
                        text="Save As Draft"
                        smallBtn
                        onClick={() => onStcApiCall("Draft")}
                      />
                    </div>
                  ) : null}
                  <div className={actStep === 1 ? "" : "ml15"}>
                    <CustomButton
                      text="Submit"
                      smallBtn
                      onClick={() => {
                        actStep === 1
                          ? onStcEntUpload()
                          : onStcApiCall("Submitted");
                      }}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the invoice?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmDelete}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={markModVsble}
        onClose={onCloseMarkMod}
        header="Confirmation"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to continue?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" onClick={onConfirmMarkYes} smallBtn />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={onCloseMarkMod}
                smallBtn
                redBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default PurchaseOrders;
